import { render, staticRenderFns } from "./PagesWidgetsList.vue?vue&type=template&id=068f72ce&"
import script from "./PagesWidgetsList.vue?vue&type=script&lang=js&"
export * from "./PagesWidgetsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports